import { fontWeight, height, lineHeight, themeGet } from 'styled-system';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { BORDER, COMMON } from '../constants';
import { getSize, getStates } from './utils';
const Button = styled.button.withConfig({
  displayName: "Button",
  componentId: "xc4i0v-0"
})(["font-family:inherit;transition:background-color 0.3s,border-color 0.3s,color 0.3s;cursor:pointer;min-width:64px;", ";", ";", ";", ";", ";", ";", " ", " &:disabled{background-color:", ";border-color:", ";color:rgba(0,0,0,0.34);cursor:not-allowed;}"], p =>
/* if button is a link or children is anything other than plain text */
p.href || p.to || typeof p.children !== 'string' ? css(["display:inline-flex;justify-content:center;align-items:center;text-decoration:none;"]) : null, fontWeight, getSize, getStates, height, lineHeight, BORDER, COMMON, themeGet('colors.gray.1'), themeGet('colors.gray.1'));
Button.defaultProps = {
  bg: 'blue',
  border: '1px solid',
  borderColor: 'blue',
  borderRadius: 2,
  color: 'white',
  fontWeight: 'semiBold',
  size: 'sm',
  variant: 'primary'
};
Button.propTypes = {
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),

  /** Disabled flag */
  disabled: PropTypes.bool,
  ...fontWeight.propTypes,

  /** Full width flag */
  fullWidth: PropTypes.bool,
  ...height.propTypes,
  href: PropTypes.string,

  /** Background Color (bg) used for background in states - overrides default use of bg prop */
  interactionBg: COMMON.propTypes.color,

  /** Color (color) used for text color in states */
  interactionColor: COMMON.propTypes.color,
  ...lineHeight.propTypes,

  /** sm, md, lg, xl */
  size: PropTypes.string,
  target: PropTypes.string,
  variant: PropTypes.string,
  ...BORDER.propTypes,
  ...COMMON.propTypes
};
Button.displayName = 'Button';
export default Button;